import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { useNavigate } from "react-router-dom";
import rightArrow from "assets/icons/arrow-right-landing.png";

const InfoBox = (props) => {
  const { infoText, linkText, heading, route } = props;
  const navigate = useNavigate();
  return (
    <Box
      className="info-box-main"
      sx={{ display: "flex", flexDirection: "column" }}
    >
      <Box className="logo" component="div" sx={{ margin: "3rem 0 3rem 0rem" }}>
        <img
          src={props.imgSrc}
          style={{ width: props?.width ? props.width : "200px" }}
        />
      </Box>
      <Box
        onClick={() => navigate(route)}
        className="sub-info-box"
        sx={{
          display: "flex",
          alignItems: "flex-start",
          flexDirection: "column",
          margin: "0 0rem",
          cursor: "pointer",
        }}
      >
        {heading.length > 0 ? (
          <Typography className="heading" variant="subtitle2" component="div">
            {heading}
          </Typography>
        ) : null}
        <Typography className="info-text" variant="body2" component="div">
          {infoText}
        </Typography>
        <Box component="div" className="animated-link">
          <Typography variant="subtitle2" className="link-text">
            {linkText}
          </Typography>
          <Box className="right-arrow">
            <img src={rightArrow} width="25px" />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default InfoBox;
